import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  SearchInput,
} from "@hid-galaxy-ui/galaxy-react";

interface UserManagementToolbarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onAddUser?: () => void;
  addButtonDisabled?: boolean;
  searchDisabled?: boolean;
}

const UserManagementToolbar: React.FC<UserManagementToolbarProps> = ({
  searchTerm,
  onSearchChange,
  onAddUser,
  addButtonDisabled = false,
  searchDisabled = false,
}) => {
  return (
    <div className="um-toolbar partner-toolbar">
      <div className="search-input-filter-wrapper">
        <div className="left">
          <SearchInput
            theme="dark"
            id="um-user-list-search"
            name="um-user-list-search"
            placeholder="Search by Name or Email"
            isDisplayClearIcon={true}
            value={searchTerm}
            disabled={searchDisabled}
            autoComplete="off"
            onChange={(event: React.FormEvent<HTMLInputElement>) =>
              onSearchChange(event.currentTarget.value)
            }
            onSearch={(_event, value) => onSearchChange(value)}
          />
        </div>
        <div className="right">
          <Button
            variant="primary"
            label="Add New User"
            className="user-management__tab-action-btn"
            icon={<Iconography icon="plus" size={IconographySizes.Medium} />}
            onClick={onAddUser}
            disabled={addButtonDisabled || !onAddUser}
          />
        </div>
      </div>
    </div>
  );
};

export default UserManagementToolbar;
